import { Component, OnInit, OnChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Settings } from 'src/app/app.settings.model';
import { AppSettings } from 'src/app/app.settings';
import { FindTimeService } from 'src/app/core/services/find-time.service';
import { Arguments } from 'src/app/core/models/arguments';
import { ApiResponseCode, TreatmentType, TreatmentStatus } from 'src/app/core/enums';
import { TranslateService } from '@ngx-translate/core';
import { TreatmentParentEntity } from 'src/app/core/interfaces/treatment-parent-entity';
import { TreatmentEntity } from 'src/app/core/interfaces/treatment-entity';
import { AppData } from 'src/app/app.data';

@Component({
  selector: 'app-select-from-card',
  templateUrl: './select-from-card.component.html',
  styleUrls: ['./select-from-card.component.scss']
})
export class SelectFromCardComponent implements OnInit {

  settings: Settings;
  form: UntypedFormGroup;
  error: string;
  selectedGroup: TreatmentParentEntity;
  hasTreatmentsFromSeries = false;


  // the original list
  private TreatmentGroup: TreatmentParentEntity[] = []; // series or plan
  private Treatments: TreatmentEntity[] = [];
  private prevSelectedTreatments: TreatmentEntity[] = [];


  constructor(private appSettings: AppSettings,
    private location: Location,
    private fb: UntypedFormBuilder,
    private findTimeService: FindTimeService,
    private translate: TranslateService,
    private appData: AppData) { }


  ngOnInit() {
    this.form = this.fb.group({
      options: ['1'],
      group: [null]
    });

    this.onChanges();
    this.prevSelectedTreatments = this.appData.treatments;
    this.hasTreatmentsFromSeries = this.appData.isSeriesSelected();
    this.loadCustomerTreatments();
    

    if (this.hasTreatmentsFromSeries) {
      this.f.options.setValue('3');
    }
  }

  get treatments(): TreatmentEntity[] {
    // filter treatment
    const type = +this.form.get('options').value;
    const group = this.form.get('group').value;

    const result = this.Treatments.filter(x => {
      // treatments
      if (type === TreatmentType.Treatment) {
        return (x.TypeID === type || x.ParentTypeID === type)
          && !x.TreatmentParentID
          && x.Active
          && x.TreatmentStatusID === TreatmentStatus.ToDo;
      } else {
        // series or plan
        if (!group) {
          return false; // must select series or plan to show treatments
        } else {
          const typeMatch = x.TypeID === type || x.ParentTypeID === type;
          const groupMatch = group ? x.TreatmentParentID === group : true;
          const todo = x.TreatmentStatusID === TreatmentStatus.ToDo;
          return typeMatch && groupMatch && todo;
        }
      }
    });
    return result;
  }

  get treatmentGroup(): TreatmentParentEntity[] {
    const type = +this.form.get('options').value;
    const result = this.TreatmentGroup ? this.TreatmentGroup.filter(x => x.TypeID === type && x.Active) : this.TreatmentGroup;
    return result;
  }





  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  // for debug only
  get diagnostic() { return JSON.stringify(this.form.value); }




  onChanges() {
    this.f.options.valueChanges.subscribe(item => {
      this.form.get('group').setValue(null); // clear group on change
    });

    this.f.group.valueChanges
      .subscribe(
        group => {
          if (!group) {
            this.selectedGroup = null;
          } else {
            this.selectedGroup = this.TreatmentGroup.find(x => x.ID === +group);
          }
        });
  }



  loadCustomerTreatments() {
    const args = this.appData.arguments;

    this.findTimeService.getCustomerTreatments(args).subscribe(
      result => {
        if (result.Code === ApiResponseCode.Success) {
          this.TreatmentGroup = result.Data.treatmentGroup as any[];
          this.Treatments = result.Data.treatments as any[];

          if(this.prevSelectedTreatments){
            this.Treatments.forEach(trt => {
                var prevTRT = this.prevSelectedTreatments.filter(x=> x.ID === trt.ID)[0];
                if(prevTRT){
                  trt.Price = prevTRT.Price;
                }
            });
          }

        } else {
          this.error = this.translate.instant(`ERROR.CODE.${result.Code}`);
        }
      },
      error => { this.error = error; }
    );
  }

  hasSelectedItems() {
    return (this.appData.treatments || []).length > 0;

  }

  totalSelected() {
    return (this.appData.treatments || []).length;
  }

  hasSelectedItemsFromPriceList() {
    return (this.appData.priceListCodes || []).length > 0;
  }

  back() {
    this.appData.treatments = this.prevSelectedTreatments;
    this.location.back();
  }

  onOK() {
    this.location.back();
  }
}
